<!-- Body Section starts -->
<div>
    <div class="main ">
        <section class="admin-content">
            <div class="tab-content  custom-tab-content">
                <div class="view-users" *ngIf="user!=null">
                     <div class="page-heading"><span class="page-title">{{user.firstName}}</span> <a class="backlink backuser-btn show"><i class="fa fa-arrow-circle-left pad-r-8"></i> <span class="back-title" tabindex="0" (keyup.enter)="backToDepartmentUsers()" (click)="backToDepartmentUsers()" > {{'store-user.Back to Users' |translate}}</span></a></div>
                    <!--VIEW USER-->
                        <div id="user-view" class="card col-xs-12 paddingbottom-10 show">
                            <div class="col-xs-12 col-sm-6 col-md-6 no-padding">
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                    <div class="col-xs-4 font-weight-700 font-14">
                                        {{'store-user.Department Name' |translate}}
                                    </div>
                                    <div class="col-xs-8">
                                        {{departmentName}}
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                    <div class="col-xs-4 font-weight-700 font-14">
                                        {{'store-user.First Name' |translate}}
                                    </div>
                                    <div class="col-xs-8">
                                        {{user.firstName}}
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                    <div class="col-xs-4 font-weight-700 font-14">
                                        {{'store-user.Middle Name' |translate}} 
                                    </div>
                                    <div class="col-xs-8">
                                        {{user.middleName}}
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                    <div class="col-xs-4 font-weight-700 font-14">
                                        {{'store-user.Last Name' |translate}}   
                                    </div>
                                    <div class="col-xs-8">
                                        {{user.lastName}}
                                    </div>
                                </div>
                              
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6">
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                    <div class="col-xs-4 font-weight-700 font-14"> {{'store-user.Email' |translate}}</div>
                                    <div class="col-xs-8">{{user.email}}</div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                    <div class="col-xs-4 font-weight-700 font-14">{{'store-user.Phone' |translate}} </div>
                                    <div class="col-xs-8">{{user.phone}}</div>
                                </div>
                               
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                    <div class="col-xs-4 font-weight-700 font-14">{{'store-user.Role Name' |translate}}
                                    </div>
                                      <div class="col-xs-8">
                                          <span *ngFor="let role of user.roles  let i=index ">{{role.name}}<span *ngIf="i!=user.roles.length-1" > , </span>   </span>
                                      </div>                        
                                </div>
                            </div>
                        </div>
                 
                </div>
            </div>
        </section>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/department/department-user-view.component.html